import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

const MainPage = () => {
    const { t, i18n } = useTranslation()

    // Function to switch languages
    const changeLanguage = (lng) => {
        i18n.changeLanguage(lng);
    };

    return (
        <>
            <div className="battle-theme">
                <div className="section1 position-relative">
                    <div className="overlay h-100 padding text-center">
                        <div className="container h-100 d-flex flex-column justify-content-between">
                            <div className='mb-5'>
                                <h4 className='text-center mb-0 mt-5 fw-semibold'>{t('Choose the event you’re attending')}</h4>
                            </div>
                            <div className="login-box mx-auto">
                                <div>
                                    <Link to="/park"><img src={require('../assets/images/battle_club_logo.PNG')} alt="" className="img-fluid" style={{ "width": "110px" }} /></Link>
                                </div>
                                {/* <div className='or2 position-relative text-center my-4 py-2'>
                                    <h4 className='mb-0 text-uppercase or-txt'>OR</h4>
                                </div>
                                <div>
                                    <Link to="/limits"><img src={require('../assets/images/logo.png')} alt="" className="img-fluid" style={{ "width": "150px" }} /></Link>
                                </div> */}
                            </div>
                            <div className='mt-5'>
                                <div className='d-flex justify-content-center align-items-center'>
                                    <Link className={`text-nowrap ${i18n.language === 'en' ? 'text-main' : ''}`} onClick={() => changeLanguage('en')}>EN</Link> 
                                    <span className='mx-2'>|</span> 
                                    <Link className={`me-2 text-nowrap ${i18n.language === 'ja' ? 'text-main' : ''}`} onClick={() => changeLanguage('ja')}>日本語</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default MainPage
